import { Customer } from "shared";
import { DriversClub } from "../DriversClub";
import { Welcome } from "../Welcome";
import { Insurance } from "../Insurance";
import { BillingAlerts } from "../BillingAlerts";

type AccountProfileProps = {
  customer: Customer;
};

export const AccountProfile = ({ customer }: AccountProfileProps) => {
  return (
    <div className="container container_center">
      <div className="d-flex justify-content-center">
        <main
          id="main"
          className="col xs-size_1-of-1 lg-size_9-of-12 xl-size_8-of-12"
        >
          <Welcome>{customer.firstName}</Welcome>
          <BillingAlerts />
          <Insurance />
          <DriversClub />
        </main>
      </div>
    </div>
  );
};
